import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import ActionToast from "../components/ActionToast";
import { useAuth } from "../hooks/useAuth";
import PreviewModal from "../views/WebsiteBuild/hooks/useOpenPreview";
import BuilderToast from "../views/WebsiteBuildPuck/Builder/lib/BuilderToast";

const damSocketContext = React.createContext();
const { Provider } = damSocketContext;

const publishMessage = (appName) =>
  `Congratulations, your ${appName || ""} app has been published!`;

const previewMessage = (appName) =>
  `The latest preview of the ${appName || ""
  } app is now available for viewing.`;

const isHttps = window.location.protocol === "https:";
const port = isHttps ? 8443 : 8080;

const useDamSocketProvider = () => {
  const { user, isAdmin } = useAuth();
  const [deployedUrl, setDeployedUrl] = useState("");
  // console.log(user, "Current User");
  const socketUrl = `${window.location.protocol}//${window.location.host}:${port}/damserver`;

  useEffect(() => {
    const socket = io(socketUrl, {
      transports: ["websocket"],
      query: {
        // bid: `${selectedBusiness?.business?.network_id}`,
        userId: `${user?.id}`,
      }, // bid <= networkId
    });
    socket.on("connect", () => {
      // eslint-disable-next-line no-console
      console.log("socket", socket.id);
    });
    // notification-${selectedBusiness?.id}
    socket.on("deploymentBuilderNotification", (data) => {
      // eslint-disable-next-line no-console
      console.log(data, "Deployed Url");
      toast.dismiss("publishStarted");
      if (data?.success) {
        if (data?.deployedUrl) {
          toast.success(<BuilderToast category="websitePublished" data={data.deployedUrl} />);
        }
      } else {
        toast.error(
          <BuilderToast
            category="publishError"
          />
        );
      }
    });

    socket.on("deploymentMobileNotification", (data) => {
      // eslint-disable-next-line no-console
      console.log(data, "Deployed Url");
      toast?.success(
        <ActionToast
          message={
            data?.completed === "Preview"
              ? previewMessage(data?.appName)
              : publishMessage(data?.appName)
          }
        />
      );

      // setDeployedUrl(data);
    });

    // socket.on("reportRun",(data:{type:"info" | "error" | "success", message:string})=>{  })
    socket.on("reportRun", (data) => {
      if (data?.type && data?.message)
        toast?.[data.type]?.(<ActionToast message={data.message} />);
      // eslint-disable-next-line no-console
      console.log({ data });
    });

    if (isAdmin) {
      socket.on("adminNotification", (data) => {
        if (data?.type && data?.message)
          toast?.[data.type]?.(<ActionToast message={data.message} />);
        // eslint-disable-next-line no-console
        console.log({ data });
      });
    }
    socket.on("disconnect", () => {
      // eslint-disable-next-line no-console
      console.log("socket", socket.id);
    });
  }, []);
  return {
    deployedUrl,
    setDeployedUrl,
  };
};

const DamServerSocketProvider = ({ children }) => {
  const value = useDamSocketProvider();

  return (
    <Provider value={value}>
      {children}
      <PreviewModal
        url={value.deployedUrl}
        close={() => {
          value.setDeployedUrl("");
        }}
      />
    </Provider>
  );
};

export const useDamSocket = () => {
  const context = useContext(damSocketContext);
  return context;
};

export default DamServerSocketProvider;
